
import { Dialog } from 'element-ui'
import { mapState } from 'vuex'
export default {
  components: {
    [Dialog.name]: Dialog
  },
  props: {
    url: {
      // 跳转地址
      type: String,
      default: ''
    }
  },
  data() {
    return {
      count: 2, // 倒计时字段
      timer1: null,
      isFlagshipStore: false,
      dialogVisible: false // 控制非旗舰店弹窗显示隐藏
    }
  },
  computed: {
    ...mapState(['mobile'])
  },
  watch: {
    dialogVisible(val) {
      if (!this.isFlagshipStore) return
      if (val) {
        this.getCount()
      } else {
        this.initData()
      }
    }
  },
  methods: {
    // 立即前往按钮点击事件
    close() {
      this.dialogVisible = false
      this.$emit('closemodefn')
    },
    immed() {
      this.createA(this.url)
      this.dialogVisible = false
    },
    open(bool = false) {
      this.isFlagshipStore = bool
      this.$nextTick(() => {
        this.dialogVisible = true
      })
    },
    // 数据初始化
    initData() {
      const timer = setTimeout(() => {
        clearTimeout(timer)
        clearTimeout(this.timer1)
        this.countdown = 0
        this.count = 2
      }, 500)
    },
    // 数字倒计时
    getCount() {
      this.timer1 = setTimeout(() => {
        if (this.timer1) clearTimeout(this.timer1)
        if (this.count > 1) {
          this.count--
          this.getCount()
        } else {
          if (this.mobile) this.createA(this.url, false)
          else this.createA(this.url)
          this.dialogVisible = false
        }
      }, 1000)
    },
    createA(url = '', isBlank = true) {
      // const a = document.createElement('a')
      // a.setAttribute('href', url)
      // if (isBlank) {
      //   a.setAttribute('target', '_blank')
      // }
      // a.setAttribute('id', 'startTelMedicine')
      this.close()
      // // 防止反复添加
      // if (document.getElementById('startTelMedicine')) document.body.removeChild(document.getElementById('startTelMedicine'))
      // document.body.appendChild(a)
      // a.click()
      window.open(`/url.html?url=${url}`)
    },
    onCopy() {
      // this.$toast(this.$t('22208'))
      const input = document.createElement('input')
      document.body.appendChild(input)
      input.setAttribute('value', this.url)
      input.select()
      document.execCommand('Copy')
      this.$message({
        message: this.$t('22208'),
        type: 'success'
      })
      document.body.removeChild(input)
    }
  }
}
